import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformLanguage } from './active-languages.transformers';
import type { ActiveLanguagesCollection } from './active-languages.types';

export function activeLanguagesReducer(
  state: CollectionStateSlice<ActiveLanguagesCollection> = {},
  action: CollectionActions<ActiveLanguagesCollection>,
): CollectionStateSlice<ActiveLanguagesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'activeLanguages') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<ActiveLanguagesCollection>(
          state,
          transformIntoDocuments(result.languages, transformLanguage),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
